import React, { lazy, Suspense, memo } from 'react'; // Use React.memo and Suspense for lazy loading
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getRandomProducts } from '../../../utils/functions';
import { PreviousBtn, NextBtn } from '../Banner/Banner';
import Product from './Product';

// Lazy load the Slider component to reduce the initial JS bundle size
const Slider = lazy(() => import('react-slick'));

// Memoizing the Product component to avoid unnecessary re-renders
const MemoizedProduct = memo(({ product }) => <Product {...product} />);

export const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 5,
    initialSlide: 1,
    swipe: true,
    prevArrow: <PreviousBtn />,
    nextArrow: <NextBtn />,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
};

const DealSlider = ({ title }) => {
    const { loading, products } = useSelector((state) => state.products);

    return (
        <section className="bg-white w-full shadow-lg rounded-lg overflow-hidden">
            {/* Header */}
            <div className="flex px-6 py-3 justify-between items-center">
                <h1 className="text-xl font-medium">{title}</h1>
                <Link to="/products" className="bg-primary-blue text-xs font-medium text-white px-5 py-2.5 rounded-sm shadow-lg">
                    VIEW ALL
                </Link>
            </div>
            <hr />
            
            {/* Slider with Suspense for lazy loading */}
            <Suspense fallback={<div className="flex justify-center items-center py-10"><p className="text-gray-500">Loading...</p></div>}>
                {loading ? (
                    <div className="flex justify-center items-center py-10">
                        <p className="text-gray-500">Loading...</p>
                    </div>
                ) : (
                    <Slider {...settings} className="p-4">
                        {products.map((product) => (
                            <div key={product._id} className="px-2 flex justify-center">
                                <MemoizedProduct product={product} />
                            </div>
                        ))}
                    </Slider>
                )}
            </Suspense>
        </section>
    );
};

export default DealSlider;
